import { Card } from '../../../card/Card'
import ProfileDetails from './profileComponents/ProfileDetails'
import ProfilePhoto from './profileComponents/profilePhoto/ProfilePhoto'

import { UserProfile } from '../../../../types/user/userProfile'

type ProfileProps = {
  userEmail: string
  profile: UserProfile | null
}

const Profile = ({ userEmail, profile }: ProfileProps) => {
  return (
    <div className="row gap-0 align-items-stretch">
      <Card className="col-12 col-xxl-4">
        <ProfilePhoto profile={profile} userEmail={userEmail} />
      </Card>
      <Card className="col-12 col-xxl-8">
        <ProfileDetails profile={profile} userEmail={userEmail} />
      </Card>
    </div>
  )
}

export default Profile
